import { apiClient } from './client';

export interface ExpeditionParticipant {
  roleCode?: string | null;
  roleName?: string | null;
  edmsAbonentId?: string | null;
  name?: string | null;
  inn?: string | null;
}
export interface ExpeditionPackage {
  id?: string;
  number?: string | null;
  name?: string | null;
  kind?: string | null;
  isDraft?: boolean;
  statusName?: string | null;
}
export interface ExpeditionItem {
  id: string;
  number?: string | null;
  statusName?: string | null;
  creationDateTime?: string | null;
  participants?: ExpeditionParticipant[];
  packages?: ExpeditionPackage[];
}
export interface ExpeditionsResponse {
  webBase: string;
  items: ExpeditionItem[];
}

export interface ExpeditionAction {
  kind: 'ForwarderApproval' | 'ForwarderReceiptIssuance' | 'OrderRevocation' | 'WarehouseReceiptIssuance';
  formalizedDocType?: string | null;
}
export interface ExpeditionActionResult {
  ok: boolean;
  signUrl: string | null;
  validation: { isValid?: boolean; errors?: string[]; warnings?: string[] } | null;
}

export const edoExpeditionsApi = {
  /** Список экспедиций (поручений) из ЭДО.МИГ24. */
  async list(): Promise<ExpeditionsResponse> {
    const { data } = await apiClient.get<ExpeditionsResponse>('/edo/expeditions');
    return data;
  },
  /** Доступные текущему участнику действия по экспедиции. */
  async actions(id: string): Promise<ExpeditionAction[]> {
    const { data } = await apiClient.get<ExpeditionAction[]>(`/edo/expeditions/${id}/actions`);
    return data;
  },
  /** Выполнить действие (согласование/расписка/отзыв) по экспедиции. */
  async performAction(id: string, kind: ExpeditionAction['kind']): Promise<ExpeditionActionResult> {
    const { data } = await apiClient.post<ExpeditionActionResult>(
      `/edo/expeditions/${id}/actions/${kind}`,
    );
    return data;
  },
};
